import { render, staticRenderFns } from "./ModalLinkOcultoRelatorioFinal.vue?vue&type=template&id=45f12ac8"
import script from "./ModalLinkOcultoRelatorioFinal.vue?vue&type=script&lang=js"
export * from "./ModalLinkOcultoRelatorioFinal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports